'use strict';

var typography = {};

exports.__exports = typography;
//# sourceMappingURL=typography4.cjs.map
